import { cva, VariantProps } from 'class-variance-authority'
import { ComponentProps } from 'react'

import { cn } from '@/shared/lib'

import { Button } from '.'

import { Icon, type Props as IconProps } from '../icon'

export const iconButtonVariants = cva('', {
  variants: {
    size: {
      small: ['h-8 min-h-8 w-8 p-1.5'],
      medium: ['h-10 w-10 p-2.5'],
      large: ['h-12 w-12 p-3.5'],
    },
  },
})

type Props = Omit<
  ComponentProps<typeof Button>,
  'bold' | 'fullWidth' | 'asChild'
> &
  VariantProps<typeof iconButtonVariants> & {
    name: IconProps['name']
  }

export const IconButton = ({
  name,
  size,
  className,
  children,
  ...restProps
}: Props) => {
  return (
    <Button
      {...restProps}
      className={cn(iconButtonVariants({ size, className }))}
    >
      <Icon name={name} size={16} />
      {children}
    </Button>
  )
}
